import React, { useState, useEffect } from "react";
import { ReactComponent as Cross } from "../assets/images/svg/Cross.svg";


const CallBackFeedback = (props) => {
    console.log(props.callbackFb,".................",props.callbackFb)
    const CloseFB = () => {
        props.setfback(false);
        props.close(false);
    };
    return (
        <>
            <div
                id="defaultModal"
                className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto bg-black bg-opacity-50"
            >
                <div className="">
                    <div
                        className="absolute left-[50%] top-[50%]  bg-white rounded-lg shadow-lg lg:w-1/2 sm:w-full p-6 transform -translate-x-1/2 -translate-y-1/2"
                    >
                        {/* Modal Content */}
                        <div className="space-y-8">
                            <div className="flex justify-between">
                                <h1 className="font-bold text-lg">Parrent Feedback</h1>
                                <div className="flex gap-4">
                                    <button className="ml-auto" onClick={CloseFB}>
                                        <Cross />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="my-2 shadow-lg p-6 bg-white">
                                {Object.entries(props.callbackFb?.fbanswer).map(([key, value]) => (
                                    <div key={key}>
                                        <strong>{key}:</strong> {value}
                                    </div>
                                ))}
                            </div>

                            <div className="my-2 shadow-lg p-6 bg-white">
                                {Object.entries(props.callbackFb?.answers).map(([key, value]) => (
                                    <div key={key}>
                                        <strong>{key}:</strong> {value}
                                    </div>
                                ))}
                            </div>

                            <div className="my-2 shadow-lg p-6 bg-white">
                                <label>Comment</label>
                                <p>{props.callbackFb?.comment }</p>
                            </div>

                            <div className="my-2 shadow-lg p-6 bg-white">
                                <label>Followup date</label>
                                <p>{props.callbackFb?.folloup }</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
export default React.memo(CallBackFeedback);